import { GridProduct } from "hub/src/components/store/ProductGrid";
import React, { createContext, useContext, useState } from "react";

interface ProductGridContextProps {
  productGridId: number | null;
  setProductGridId: (id: number | null) => void;
  fullProductList: GridProduct[];
  setFullProductList: React.Dispatch<React.SetStateAction<GridProduct[]>>;
  productGridSearch: string;
}

export const ProductGridContext = createContext<
  ProductGridContextProps | undefined
>(undefined);

export const ProductGridProvider: React.FC<{
  children: React.ReactNode;
  productGridSearch: string;
}> = ({ children, productGridSearch }) => {
  const [productGridId, setProductGridId] = useState<number | null>(null);
  const [fullProductList, setFullProductList] = useState<GridProduct[]>([]);

  return (
    <ProductGridContext.Provider
      value={{
        fullProductList,
        setFullProductList,
        productGridId,
        setProductGridId,
        productGridSearch,
      }}
    >
      {children}
    </ProductGridContext.Provider>
  );
};

export const useProductGrid = (): ProductGridContextProps => {
  const context = useContext(ProductGridContext);
  if (!context) {
    throw new Error(
      "useProductGrid must be used within an ProductGridProvider",
    );
  }
  return context;
};
